/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer to type instead of draw?`)
};

const es_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Prefieres escribir en lugar de dibujar?`)
};

const de_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie lieber eingeben statt zeichnen?`)
};

const nl_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liever typen dan tekenen?`)
};

const fr_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préférez-vous taper au lieu de dessiner?`)
};

const it_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferisci digitare invece di disegnare?`)
};

const pt_br2_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefere digitar em vez de desenhar?`)
};

const pt_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefere escrever em vez de desenhar?`)
};

const ja_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描くのではなく入力を好みますか?`)
};

const zh_sig_hub_type_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更喜欢输入而不是绘制？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_type_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_type_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_type_hint", locale)
	if (locale === "en") return en_sig_hub_type_hint(inputs)
	if (locale === "es") return es_sig_hub_type_hint(inputs)
	if (locale === "de") return de_sig_hub_type_hint(inputs)
	if (locale === "nl") return nl_sig_hub_type_hint(inputs)
	if (locale === "fr") return fr_sig_hub_type_hint(inputs)
	if (locale === "it") return it_sig_hub_type_hint(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_type_hint(inputs)
	if (locale === "pt") return pt_sig_hub_type_hint(inputs)
	if (locale === "ja") return ja_sig_hub_type_hint(inputs)
	return zh_sig_hub_type_hint(inputs)
};